<app-revenue-graphic-card [revenue]="revenue$ | async" />
